module.exports = __webpack_public_path__ + "img/p3.a3111e9e.png";